module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_9.c4d7b8d6.png";